export const COLLECTIBLE_TEASER_DISMISSED_KEY =
  "statsfan.trivia.collectibleTeaser.dismissed";

const resolveStorage = (storage) => {
  if (storage !== undefined) return storage;
  return typeof window === "undefined" ? null : window.localStorage;
};

export const isCollectibleTeaserDismissed = (storage) => {
  try {
    return (
      resolveStorage(storage)?.getItem?.(COLLECTIBLE_TEASER_DISMISSED_KEY) ===
      "1"
    );
  } catch {
    return false;
  }
};

export const writeCollectibleTeaserDismissed = (storage) => {
  try {
    resolveStorage(storage)?.setItem?.(COLLECTIBLE_TEASER_DISMISSED_KEY, "1");
  } catch {
    // Private mode / quota: keep the in-memory hide; next load shows the banner.
  }
};
